import React from 'react';
import getDataById from '@lba-dev/package.local-globals/getDataById';
import { I_ENC, I_VRF, I_ANN } from '@lba-dev/package.local-globals/iStatus';
import ReactEcharts from 'echarts-for-react';

import Money from '../../utils/Money';

const getOptions = (data) => {
  const ENC = getDataById.intervention[I_ENC];
  const VRF = getDataById.intervention[I_VRF];
  const ANN = getDataById.intervention[I_ANN];
  return {
    tooltip: {
      formatter: (params) => params.name !== 'Panier moyen'
        ? `${params.name}: ${params.value} (${params.percent}%)`
        : '',
    },
    series: [
      {
        name: '',
        type: 'pie',
        color: ['transparent'],
        radius: [0, '35%'],
        label: {
          formatter: '{b}\n {c} €',
          position: 'center',
          color: '#000',
          fontSize: 14,
          fontWeight: 'bold'
        },
        labelLine: { show: false },
        data: [{
          value: Money.toString(data.panierMoyen),
          name: 'Panier moyen'
        }]
      },
      {
        name: '',
        type: 'pie',
        color: [ENC.color[500], VRF.color[500], ANN.color[500]],
        radius: ['40%', '60%'],
        label: { fontWeight: 'bold' },
        data: [
          { value: data.nbEnCours, name: ENC.name },
          { value: data.nbVerifie, name: VRF.name },
          { value: data.nbAnnule, name: ANN.name },
        ]
      }
    ]
  };
};

export const Graphic = ({ artisan, intervention }) => {

  const data = (artisan && artisan.intervention) || intervention;
  if (data === undefined) {
    return null;
  }
  return <ReactEcharts
    notMerge
    option={getOptions(data)}
  />;
};
